(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-stessia-color-finder-v2]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.dataset.scfInitialized === 'true') return;
    root.dataset.scfInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var dataNode = root.querySelector('[data-scf-color-data]');
    var configNode = root.querySelector('[data-scf-config]');
    if (!dataNode || !configNode) return;

    var colorData;
    var config;
    try {
      colorData = JSON.parse(dataNode.textContent);
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      root.classList.add('scf-v2--error');
      return;
    }

    var colors = colorData.colors || [];
    var product = config.product || {};
    var variants = product.variants || [];
    var productUrls = {
      '1': '/products/premium-butterfly-weft%E2%84%A2-extensions-55-cm',
      '1a': '/products/premium-invisible-butterfly-weft-extensions-1a',
      '1b': '/products/premium-invisible-butterfly-weft-extensions-1b',
      '2': '/products/premium-invisible-butterfly-weft-extensions-2',
      '3': '/products/premium-invisible-butterfly-weft-extensions-3',
      '4': '/products/premium-invisible-butterfly-weft-extensions-4',
      '5': '/products/premium-invisible-butterfly-weft-extensions-5',
      '6': '/products/premium-invisible-butterfly-weft-extensions-6',
      '8': '/products/premium-invisible-butterfly-weft-extensions-8',
      '99j': '/products/premium-invisible-butterfly-weft-extensions-99j',
      '30': '/products/premium-invisible-butterfly-weft-extensions-30',
      '33': '/products/premium-invisible-butterfly-weft-extensions-33',
      'ivory': '/products/premium-invisible-butterfly-weft-extensions-613-vanilla-blond-kopie',
      '60': '/products/premium-invisible-butterfly-weft-extensions-60',
      '613': '/products/premium-invisible-butterfly-weft-extensions-613',
      'silver': '/products/premium-invisible-butterfly-weft-extensions-ivory-kopie',
      '4-6-h': '/products/premium-invisible-butterfly-weft-extensions-4-6-highlights',
      '4-8-18-h': '/products/premium-invisible-butterfly-weft-extensions-4-8-18-highlights',
      '10-24-h': '/products/premium-invisible-butterfly-weft-extensions-10-24-highlights',
      '6-24-h': '/products/premium-invisible-butterfly-weft-extensions-6-24-highlights',
      '8-613-h': '/products/premium-invisible-butterfly-weft-extensions-8-613-highlights',
      'm18-613-h': '/products/premium-invisible-butterfly-weft-extensions-m18-613-highlights',
      '613-18-h': '/products/premium-invisible-butterfly-weft-extensions-613-18-highlights',
      '613-18a-h': '/products/premium-invisible-butterfly-weft-extensions-613-18a-highlights',
      '1bt-2-4-b': '/products/premium-genius-butterfly-hole-weft-extensions-1bt1b-4-oak-balayage-kopie',
      '6-27t24-b': '/search?q=%236%2F27T24&type=product',
      '10-24-b': '/products/premium-genius-butterfly-hole-weft-extensions-10-24-balayage',
      '1b-6-b': '/products/premium-genius-butterfly-hole-weft-extensions-silver-kopie',
      '3-3t24-b': '/products/premium-genius-butterfly-hole-weft-extensions-3-3t24-balayage',
      '7-613-18a-b': '/search?q=%237%2F613%2F18A&type=product',
      '6-6t24-b': '/products/premium-genius-butterfly-hole-weft-extensions-6-6t24-balayage',
      '3t8-613-b': '/products/premium-genius-butterfly-hole-weft-extensions-3t8-613-balayage',
      '7a-613-18a-b': '/products/premium-genius-butterfly-hole-weft-extensions-7a-613-18a-balayage',
      '5a-613-18-b': '/products/premium-genius-butterfly-hole-weft-extensions-5a-613-18-balayage',
      '1bt1b-4-oak-b': '/products/premium-genius-butterfly-hole-weft-extensions-1bt1b-4-oak-balayage',
      '4-8-18-b': '/products/premium-genius-butterfly-hole-weft-extensions-4-8-18-balayage',
      '8a-10-r': '/products/premium-genius-butterfly-hole-weft-extensions-8a-10-rooted',
      '8t60-r': '/products/premium-genius-butterfly-hole-weft-extensions-8t60-rooted'
    };
    var state = { step: 0, answers: {}, result: null };
    var storageKey = 'stessia-color-match-v2-' + sectionId;

    var questions = [
      {
        key: 'depth',
        eyebrow: 'Your current hair color',
        title: 'How do your lengths and ends look in daylight?',
        help: 'Go by the range the extensions fall into – not only by your roots.',
        answers: [
          { value: 'black', label: 'Black to black-brown', copy: 'Very deep, almost black lengths.', imageId: '1b', depth: 1.6 },
          { value: 'dark-brown', label: 'Dark brown', copy: 'Deep brown, but not black.', imageId: '3', depth: 3.2 },
          { value: 'medium-brown', label: 'Medium brown', copy: 'Classic brown with medium depth.', imageId: '4', depth: 4.3 },
          { value: 'light-brown', label: 'Light brown to dark blonde', copy: 'Between brown and blonde.', imageId: '6', depth: 5.8 },
          { value: 'medium-blonde', label: 'Medium blonde', copy: 'Clearly blonde, but not very light.', imageId: '8', depth: 7.3 },
          { value: 'light-blonde', label: 'Light blonde to platinum', copy: 'Very light blonde lengths and ends.', imageId: '613', depth: 9.4 },
          { value: 'red-copper', label: 'Red, copper or burgundy', copy: 'Clearly reddish or coppery reflections.', imageId: '30', depth: 5.4, toneFamily: 'red' },
          { value: 'unsure', label: 'I am not sure', copy: 'The brightness changes a lot depending on the light.', imageId: '4-8-18-h', unsure: true }
        ]
      },
      {
        key: 'tone',
        eyebrow: 'Undertone',
        title: 'Which reflections do you see in indirect daylight?',
        help: 'Compare by a window without filters and without direct sunlight.',
        answers: [
          { value: 'cool', label: 'Cool or ashy', copy: 'Smoky, silvery or matte – little gold.', imageId: 'silver', tone: 'cool' },
          { value: 'neutral', label: 'Neutral or beige', copy: 'Neither clearly warm nor clearly cool.', imageId: '8', tone: 'neutral' },
          { value: 'warm', label: 'Warm or golden', copy: 'Honey, gold or vanilla reflections.', imageId: '613', tone: 'warm' },
          { value: 'copper', label: 'Copper or auburn', copy: 'Orange-copper to warm red-brown reflections.', imageId: '30', tone: 'copper' },
          { value: 'red', label: 'Red or burgundy', copy: 'Cool to deep red or burgundy reflections.', imageId: '99j', tone: 'red' },
          { value: 'unsure', label: 'I am not sure', copy: 'My hair looks different depending on the light.', imageId: 'm18-613-h', unsure: true }
        ]
      },
      {
        key: 'pattern',
        eyebrow: 'Color structure',
        title: 'How is your hair color structured?',
        help: 'Note whether several nuances or a transition should stay visible.',
        answers: [
          { value: 'solid', label: 'Largely one solid color', copy: 'A calm, even color direction.', imageId: '4', pattern: 'solid' },
          { value: 'highlights', label: 'Naturally highlighted', copy: 'Fine light and darker strands.', imageId: '4-8-18-h', pattern: 'highlights' },
          { value: 'balayage', label: 'balayage transition', copy: 'Flowing transition to lighter lengths.', imageId: '3t8-613-b', pattern: 'balayage' },
          { value: 'rooted', label: 'Rooted / darker roots', copy: 'Darker base with clearly lighter lengths.', imageId: '8t60-r', pattern: 'rooted' },
          { value: 'unsure', label: 'I am not sure', copy: 'Several options could fit.', imageId: '7a-613-18a-b', unsure: true }
        ]
      },
      {
        key: 'rootShift',
        eyebrow: 'Roots and ends',
        title: 'How much do roots and ends differ?',
        help: 'This detail helps especially with balayage and rooted colors.',
        answers: [
          { value: 'same', label: 'About the same', copy: 'Only slight differences from roots to ends.', imageId: '8', rootShift: 0 },
          { value: 'slightly-darker', label: 'Roots slightly darker', copy: 'A soft, natural difference in depth.', imageId: '8a-10-r', rootShift: 1 },
          { value: 'clearly-darker', label: 'Roots clearly darker', copy: 'Clear root with lighter lengths.', imageId: '3t8-613-b', rootShift: 2 },
          { value: 'strong-contrast', label: 'Very strong transition', copy: 'Deep base and clearly lighter ends.', imageId: '1b-6-b', rootShift: 3 },
          { value: 'unsure', label: 'I am not sure', copy: 'The transition is hard to place.', imageId: '4-8-18-b', unsure: true }
        ]
      },
      {
        key: 'goal',
        eyebrow: 'Your result',
        title: 'What matters most to you in the color result?',
        help: 'Your own hair color remains decisive. Your goal only refines the ranking.',
        answers: [
          { value: 'natural', label: 'Invisible integration', copy: 'The extensions should blend in as naturally as possible.', imageId: '4-6-h', goal: 'natural' },
          { value: 'brighter', label: 'Look slightly lighter', copy: 'More lightness and lighter lengths.', imageId: '8-613-h', goal: 'brighter' },
          { value: 'dimension', label: 'More dimension', copy: 'More movement through several nuances.', imageId: '4-8-18-h', goal: 'dimension' },
          { value: 'balayage', label: 'Blend the transition softly', copy: 'Bring roots and ends together more harmoniously.', imageId: '7-613-18a-b', goal: 'balayage' },
          { value: 'depth', label: 'More depth', copy: 'A calmer, denser or darker overall impression.', imageId: '3', goal: 'depth' },
          { value: 'unsure', label: 'I need advice', copy: 'I would rather confirm the direction.', imageId: 'm18-613-h', unsure: true }
        ]
      }
    ];

    var els = {
      intro: root.querySelector('[data-scf-intro-screen]'),
      quiz: root.querySelector('[data-scf-quiz-screen]'),
      result: root.querySelector('[data-scf-result-screen]'),
      start: root.querySelector('[data-scf-start]'),
      question: root.querySelector('[data-scf-question]'),
      progress: root.querySelector('[data-scf-progress]'),
      progressLabel: root.querySelector('[data-scf-progress-label]'),
      back: root.querySelector('[data-scf-back]'),
      next: root.querySelector('[data-scf-next]'),
      summary: root.querySelector('[data-scf-summary]'),
      previews: root.querySelectorAll('[data-scf-preview]'),
      restart: root.querySelector('[data-scf-restart]'),
      resultContent: root.querySelector('[data-scf-result-content]')
    };

    function emit(name, detail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name, section_id: sectionId }, detail || {}));
    }

    function colorById(id) {
      return colors.find(function (color) { return color.id === id; }) || colors[0];
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/highlights?/g, 'highlights')
        .replace(/balayage/g, 'balayage')
        .replace(/rooted/g, 'rooted')
        .replace(/:/g, '/')
        .replace(/[^a-z0-9/]+/g, '');
    }

    function attachVariant(color) {
      if (!variants.length) return color;
      var expected = normalize(color.variantLabel);
      var codeOnly = normalize(color.code);
      var needsType = /highlights|balayage|rooted/i.test(color.variantLabel);
      var match = variants.find(function (variant) {
        var optionValues = (variant.options || []).map(normalize);
        if (optionValues.indexOf(expected) > -1) return true;
        var haystack = normalize([variant.title].concat(variant.options || []).join(' '));
        if (needsType) return haystack.indexOf(expected) > -1;
        return optionValues.indexOf(codeOnly) > -1 || haystack === codeOnly;
      });
      if (!match) return color;
      color.variantId = match.id;
      color.productUrl = match.url || product.url;
      if (match.image) color.variantImage = match.image;
      return color;
    }

    colors.forEach(function (color) {
      if (productUrls[color.id]) color.productUrl = productUrls[color.id];
      attachVariant(color);
    });

    function imageFor(color) {
      return color.variantImage || color.image;
    }

    function saveState() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ step: state.step, answers: state.answers }));
      } catch (error) {}
    }

    function clearState() {
      try { localStorage.removeItem(storageKey); } catch (error) {}
    }

    function selectedAnswer(question) {
      var selected = state.answers[question.key];
      if (!selected) return null;
      return question.answers.find(function (answer) { return answer.value === selected; }) || null;
    }

    function renderPreview(color, label) {
      if (!color || !els.previews.length) return;
      var markup =
        '<div class="scf-v2__preview-media">' +
          '<img src="' + escapeHtml(imageFor(color)) + '" alt="' + escapeHtml(color.code + ' ' + color.name) + '" width="900" height="900">' +
          '<span class="scf-v2__preview-tag">' + escapeHtml(label || 'Color example') + '</span>' +
        '</div>' +
        '<div class="scf-v2__preview-copy">' +
          '<strong>' + escapeHtml(color.code) + '</strong>' +
          '<span>' + escapeHtml(color.name) + '</span>' +
        '</div>';
      els.previews.forEach(function (preview) {
        preview.innerHTML = markup;
      });
    }

    function renderSummary() {
      if (!els.summary) return;
      var items = questions.slice(0, state.step + 1).map(function (question) {
        var answer = selectedAnswer(question);
        if (!answer) return '';
        return '<span><small>' + escapeHtml(question.eyebrow) + '</small>' + escapeHtml(answer.label) + '</span>';
      }).filter(Boolean);
      els.summary.innerHTML = items.join('');
    }

    function renderQuestion() {
      var question = questions[state.step];
      var selected = selectedAnswer(question);
      var cards = question.answers.map(function (answer) {
        var reference = colorById(answer.imageId);
        var isSelected = selected && selected.value === answer.value;
        return (
          '<button type="button" class="scf-v2__answer' + (isSelected ? ' is-selected' : '') + '" data-answer="' + escapeHtml(answer.value) + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '">' +
            '<span class="scf-v2__answer-media"><img src="' + escapeHtml(imageFor(reference)) + '" alt="" width="900" height="900" loading="lazy"></span>' +
            '<span class="scf-v2__answer-body"><strong>' + escapeHtml(answer.label) + '</strong><small>' + escapeHtml(answer.copy) + '</small></span>' +
            '<span class="scf-v2__answer-check" aria-hidden="true">✓</span>' +
          '</button>'
        );
      }).join('');

      els.question.innerHTML =
        '<div class="scf-v2__question-head">' +
          '<p>' + escapeHtml(question.eyebrow) + '</p>' +
          '<h3 tabindex="-1">' + escapeHtml(question.title) + '</h3>' +
          '<span>' + escapeHtml(question.help) + '</span>' +
        '</div>' +
        '<div class="scf-v2__answers">' + cards + '</div>';

      els.progress.style.width = (((state.step + 1) / questions.length) * 100) + '%';
      els.progressLabel.textContent = 'Question ' + (state.step + 1) + ' of ' + questions.length;
      els.back.disabled = state.step === 0;
      els.next.disabled = !selected;
      els.next.textContent = state.step === questions.length - 1 ? 'Show result' : 'Next';
      renderSummary();

      if (selected) renderPreview(colorById(selected.imageId), selected.label);

      els.question.querySelectorAll('[data-answer]').forEach(function (button) {
        button.addEventListener('click', function () {
          var answer = question.answers.find(function (item) { return item.value === button.dataset.answer; });
          if (!answer) return;
          state.answers[question.key] = answer.value;
          saveState();
          renderQuestion();
          renderPreview(colorById(answer.imageId), answer.label);
          emit('stessia_color_match_answer', { question: question.key, answer: answer.value, step: state.step + 1 });
        });
      });
    }

    function scoreColor(color) {
      var score = 0;
      var depthAnswer = selectedAnswer(questions[0]);
      var toneAnswer = selectedAnswer(questions[1]);
      var patternAnswer = selectedAnswer(questions[2]);
      var rootAnswer = selectedAnswer(questions[3]);
      var goalAnswer = selectedAnswer(questions[4]);

      if (depthAnswer && !depthAnswer.unsure) {
        score += Math.max(0, 44 - Math.abs(color.depth - depthAnswer.depth) * 10);
        if (depthAnswer.toneFamily === 'red') {
          score += color.tone === 'red' || color.tone === 'copper' ? 24 : -22;
        } else if (color.tone === 'red' || color.tone === 'copper') {
          score -= 28;
        }
      }

      if (toneAnswer && !toneAnswer.unsure) {
        if (color.tone === toneAnswer.tone) {
          score += 24;
        } else if (color.tone === 'neutral' || toneAnswer.tone === 'neutral') {
          score += 10;
        } else {
          score -= 8;
        }
      }

      if (patternAnswer && !patternAnswer.unsure) {
        if (color.pattern === patternAnswer.pattern) {
          score += 28;
        } else if (patternAnswer.pattern === 'highlights' && color.pattern === 'balayage') {
          score += 5;
        } else if (patternAnswer.pattern === 'rooted' && color.pattern === 'balayage' && color.rootShift >= 2) {
          score += 14;
        } else {
          score -= 18;
        }
      }

      if (rootAnswer && !rootAnswer.unsure) {
        score += Math.max(-10, 20 - Math.abs(color.rootShift - rootAnswer.rootShift) * 10);
      }

      if (goalAnswer && !goalAnswer.unsure) {
        score += color.goals.indexOf(goalAnswer.goal) > -1 ? 14 : 0;
      }

      if (!color.verified) score -= 18;
      return Math.round(score * 10) / 10;
    }

    function confidenceFor(ranked) {
      var uncertain = questions.filter(function (question) {
        var answer = selectedAnswer(question);
        return !answer || answer.unsure;
      }).length;
      var top = ranked[0] ? ranked[0].score : 0;
      var margin = ranked[1] ? top - ranked[1].score : top;
      if (uncertain === 0 && top >= 100 && margin >= 8) return { key: 'high', label: 'High match', copy: 'Your answers give a clear color profile.' };
      if (uncertain <= 1 && top >= 78) return { key: 'medium', label: 'Good guidance', copy: 'Two or more color directions are relatively close together.' };
      return { key: 'support', label: 'Please confirm additionally', copy: 'Color samples or daylight photos increase certainty.' };
    }

    function toneLabel(tone) {
      return { cool: 'cool/ ashy', neutral: 'neutral/beige', warm: 'warm/golden', copper: 'coppery', red: 'reddish' }[tone] || tone;
    }

    function patternLabel(pattern) {
      return { solid: 'calm solid structure', highlights: 'fine highlights', balayage: 'balayage transition', rooted: 'rooted transition' }[pattern] || pattern;
    }

    function alternativeDifference(primary, color) {
      var notes = [];
      if (color.depth < primary.depth - 0.5) notes.push('darker');
      if (color.depth > primary.depth + 0.5) notes.push('lighter');
      if (color.tone !== primary.tone) notes.push(toneLabel(color.tone));
      if (color.pattern !== primary.pattern) notes.push(patternLabel(color.pattern));
      if (!notes.length) notes.push('similar color depth');
      return notes.slice(0, 2).join(' · ');
    }

    function productLink(color) {
      return color.productUrl || product.url || config.fallbackProductUrl || '#';
    }

    function colorCard(color, primary) {
      var unverified = !color.verified ? '<span class="scf-v2__verification">Reference image under review</span>' : '';
      return (
        '<article class="scf-v2__color-card' + (primary ? ' scf-v2__color-card--primary' : '') + '">' +
          '<div class="scf-v2__color-image"><img src="' + escapeHtml(imageFor(color)) + '" alt="Product color ' + escapeHtml(color.code + ' ' + color.name) + '" width="900" height="900" loading="lazy">' + unverified + '</div>' +
          '<div class="scf-v2__color-copy">' +
            '<p>' + escapeHtml(color.category) + '</p>' +
            '<h4><strong>' + escapeHtml(color.code) + '</strong> ' + escapeHtml(color.name) + '</h4>' +
            (!primary && state.result ? '<span>' + escapeHtml(alternativeDifference(state.result.primary, color)) + '</span>' : '') +
          '</div>' +
        '</article>'
      );
    }

    function renderResult() {
      var ranked = colors.map(function (color) {
        return { color: color, score: scoreColor(color) };
      }).sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (a.color.verified !== b.color.verified) return a.color.verified ? -1 : 1;
        return a.color.depth - b.color.depth;
      });

      var verifiedRanked = ranked.filter(function (item) { return item.color.verified; });
      var primaryEntry = verifiedRanked[0] || ranked[0];
      var primary = primaryEntry.color;
      var alternatives = ranked.filter(function (item) { return item.color.id !== primary.id; }).slice(0, 3).map(function (item) { return item.color; });
      var confidence = confidenceFor(ranked);
      var toneAnswer = selectedAnswer(questions[1]);
      var patternAnswer = selectedAnswer(questions[2]);
      var rootAnswer = selectedAnswer(questions[3]);
      state.result = { primary: primary, alternatives: alternatives, confidence: confidence, ranked: ranked };

      var reasons = [
        'The color depth is closest to the brightness you chose.',
        toneAnswer && !toneAnswer.unsure ? 'The color effect is ' + toneLabel(primary.tone) + '.' : 'The undertone should also be checked in daylight.',
        patternAnswer && !patternAnswer.unsure ? 'The color shows a ' + patternLabel(primary.pattern) + '.' : 'The color transition should also be compared.'
      ];
      if (rootAnswer && !rootAnswer.unsure && primary.rootShift > 0) reasons.push('The root transition supports the brightness difference you chose.');

      var actions =
        '<a class="scf-v2__button scf-v2__button--primary" href="' + escapeHtml(productLink(primary)) + '">View this color</a>' +
        (config.sampleUrl ? '<a class="scf-v2__button scf-v2__button--secondary" href="' + escapeHtml(config.sampleUrl) + '">Check color samples</a>' : '') +
        (config.consultationUrl ? '<a class="scf-v2__text-link" href="' + escapeHtml(config.consultationUrl) + '">Advice with daylight photos</a>' : '');

      els.resultContent.innerHTML =
        '<div class="scf-v2__result-heading">' +
          '<p>Your most likely best Color Match</p>' +
          '<h3>' + escapeHtml(primary.code) + ' · ' + escapeHtml(primary.name) + '</h3>' +
          '<div class="scf-v2__confidence scf-v2__confidence--' + confidence.key + '"><strong>' + escapeHtml(confidence.label) + '</strong><span>' + escapeHtml(confidence.copy) + '</span></div>' +
        '</div>' +
        '<div class="scf-v2__result-grid">' +
          colorCard(primary, true) +
          '<div class="scf-v2__match-reasons"><p>Why this color ranks first</p><ul>' + reasons.map(function (reason) { return '<li>' + escapeHtml(reason) + '</li>'; }).join('') + '</ul><div class="scf-v2__result-actions">' + actions + '</div></div>' +
        '</div>' +
        '<div class="scf-v2__alternative-section">' +
          '<div class="scf-v2__section-title"><div><p>Compare directly</p><h3>Your closest alternatives</h3></div><span>Check brightness, undertone and transition side by side.</span></div>' +
          '<div class="scf-v2__alternative-grid">' + alternatives.map(function (color) { return colorCard(color, false); }).join('') + '</div>' +
        '</div>' +
        '<div class="scf-v2__safety">' +
          '<div><p>Decide with confidence</p><h3>Check your color in real daylight.</h3></div>' +
          '<ul><li>Photograph your hair loose by a window.</li><li>Show roots, lengths and ends clearly.</li><li>Use no filters and no direct sunlight.</li></ul>' +
        '</div>' +
        '<p class="scf-v2__disclaimer">The recommendation is individual guidance based on your answers, not a color guarantee. Screen, light and your own hair can change how a color is perceived.</p>';

      els.quiz.hidden = true;
      els.intro.hidden = true;
      els.result.hidden = false;
      root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      emit('stessia_color_match_result', {
        color_code: primary.variantLabel,
        confidence: confidence.key,
        alternatives: alternatives.map(function (color) { return color.variantLabel; })
      });
    }

    function startQuiz() {
      els.intro.hidden = true;
      els.result.hidden = true;
      els.quiz.hidden = false;
      renderQuestion();
      emit('stessia_color_match_start');
    }

    function resetQuiz() {
      state = { step: 0, answers: {}, result: null };
      clearState();
      els.result.hidden = true;
      els.intro.hidden = false;
      els.quiz.hidden = true;
      renderPreview(colorById('4-8-18-h'), 'Example: highlights');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    els.start.addEventListener('click', startQuiz);
    els.back.addEventListener('click', function () {
      if (state.step === 0) return;
      state.step -= 1;
      saveState();
      renderQuestion();
    });
    els.next.addEventListener('click', function () {
      if (!selectedAnswer(questions[state.step])) return;
      if (state.step < questions.length - 1) {
        state.step += 1;
        saveState();
        renderQuestion();
        var heading = els.question.querySelector('h3');
        if (heading) heading.focus();
      } else {
        renderResult();
      }
    });
    els.restart.addEventListener('click', resetQuiz);

    renderPreview(colorById('4-8-18-h'), 'Example: highlights');
  });
})();
